import { API_CACHE_KEYS, API_PATHS } from '@/modules/common/constants';
import { ApiClient } from '@pw-tech/web-sdk';
import { useMutation } from '@tanstack/react-query';

export const useApplyCoupon = () => {
  const { isLoading, isPending, error, mutate } = useMutation(
    [API_CACHE_KEYS.APPLY_COUPON],
    (body: any) => {
      return ApiClient.post(API_PATHS.APPLY_COUPON, body);
    }
  );

  return {
    error,
    isLoading,
    isPending,
    mutate,
  };
};
